import { ArrowUpRight } from "lucide-react";
import { IMAGES, PRODUCTS, PROCESS } from "@/data/content";
import { MaskedLines, Reveal } from "./Reveal";

export const Manufacturing = () => (
  <section id="products" className="section section-cream manufacturing" data-testid="manufacturing-section">
    <Reveal>
      <p className="mono-label accent">02 / Manufacturing</p>
    </Reveal>
    <div className="manufacturing-head">
      <MaskedLines
        as="h2"
        className="section-title"
        lines={["Engineered to"]}
        data-testid="manufacturing-title"
      />
      <MaskedLines as="h2" className="section-title serif-italic" delay={0.12} lines={["endure."]} />
      <Reveal delay={0.2} className="manufacturing-sub">
        <p>OEM-grade pins and bushes built to perform under pressure, impact, and long service cycles.</p>
      </Reveal>
    </div>

    <div className="product-grid">
      {PRODUCTS.map((p, i) => (
        <Reveal key={p.num} delay={i * 0.1} y={36} className="product-card" data-testid={`product-card-${i + 1}`}>
          <span className="mono-label accent">{p.num}</span>
          <h3>{p.title}</h3>
          <p>{p.desc}</p>
          <span className="card-arrow">
            <ArrowUpRight size={22} />
          </span>
        </Reveal>
      ))}
    </div>

    <div className="process" data-testid="process-strip">
      <Reveal>
        <p className="mono-label">Fully in-house process</p>
      </Reveal>
      <div className="process-grid">
        {PROCESS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.08} y={24} className="process-step" data-testid={`process-step-${i + 1}`}>
            <span className="mono-label accent">{s.num}</span>
            <h4>{s.title}</h4>
            <p>{s.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>

    <div className="works" data-testid="works-gallery">
      <Reveal>
        <p className="mono-label accent">On the shop floor</p>
      </Reveal>
      <Reveal delay={0.1} className="works-video">
        <video
          src={IMAGES.factoryVideo}
          poster={IMAGES.factoryFloor}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          data-testid="works-video"
        />
        <span className="mono-label image-caption">Live from our works.</span>
      </Reveal>
      <div className="works-photos">
        {[
          { img: IMAGES.grindingSparks, label: "Precision grinding" },
          { img: IMAGES.cncTurning, label: "CNC turning" },
          { img: IMAGES.heatTreatment, label: "Heat treatment" },
          { img: IMAGES.finishedPins, label: "Finished pins" },
          { img: IMAGES.finishedBushes, label: "Finished bushes" },
          { img: IMAGES.inspection, label: "Final inspection" },
        ].map((p, i) => (
          <Reveal key={p.label} delay={i * 0.08} y={28} className="works-photo" data-testid={`works-photo-${i + 1}`}>
            <img src={p.img} alt={p.label} loading="lazy" />
            <span className="mono-label">{p.label}</span>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
